// @flow

export const WS_INIT_DEPOSIT = 'WS_INIT_DEPOSIT';
export const WS_INIT_DEPOSIT_SUCCESS = 'WS_INIT_DEPOSIT_SUCCESS';
export const WS_DISCONNECTED_DEPOSIT = 'WS_DISCONNECTED_DEPOSIT';
export const WS_CLEAR_DEPOSIT_RESPONSES = 'WS_CLEAR_DEPOSIT_RESPONSES';

export const WS_CHECK_DEPOSIT_REQUEST = 'WS_CHECK_DEPOSIT_REQUEST';
export const WS_CHECK_DEPOSIT_ERROR = 'WS_CHECK_DEPOSIT_ERROR';
export const WS_CHECK_DEPOSIT_SUCCESS = 'WS_CHECK_DEPOSIT_SUCCESS';

export const WS_LIST_AVAILABLE_DEPOSIT_METHODS_REQUEST
  = 'WS_LIST_AVAILABLE_DEPOSIT_METHODS_REQUEST';
export const WS_LIST_AVAILABLE_DEPOSIT_METHODS_ERROR
  = 'WS_LIST_AVAILABLE_DEPOSIT_METHODS_ERROR';
export const WS_LIST_AVAILABLE_DEPOSIT_METHODS_SUCCESS
  = 'WS_LIST_AVAILABLE_DEPOSIT_METHODS_SUCCESS';

export const WS_SCAN_CREDIT_CARD_REQUEST = 'WS_SCAN_CREDIT_CARD_REQUEST';
export const WS_SCAN_CREDIT_CARD_ERROR = 'WS_SCAN_CREDIT_CARD_ERROR';
export const WS_SCAN_CREDIT_CARD_SUCCESS = 'WS_SCAN_CREDIT_CARD_SUCCESS';

export const WS_START_DEPOSIT_REQUEST = 'WS_START_DEPOSIT_REQUEST';
export const WS_START_DEPOSIT_ERROR = 'WS_START_DEPOSIT_ERROR';
export const WS_START_DEPOSIT_SUCCESS = 'WS_START_DEPOSIT_SUCCESS';
